import { render, staticRenderFns } from "./FeedbacksPanel.vue?vue&type=template&id=38d63022&scoped=true"
import script from "./FeedbacksPanel.vue?vue&type=script&lang=js"
export * from "./FeedbacksPanel.vue?vue&type=script&lang=js"
import style0 from "./FeedbacksPanel.vue?vue&type=style&index=0&id=38d63022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d63022",
  null
  
)

export default component.exports